import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { connect, ConnectedProps } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../redux/reduxActions';
import {
  AzureMapsProvider,
  IAzureMapOptions,
} from 'react-azure-maps';
import * as atlas from 'azure-maps-control';
import "./map.css";
import { GEOFencingGroupCoordinates } from '../models/models';

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const options: IAzureMapOptions = {
  authOptions: {
    authType: atlas.AuthenticationType.subscriptionKey,
    subscriptionKey: 'EkWMGGuCQAoJ6YgQ3ckvbAHOUqJ2qpUAboFTuVjDG2uoYYWMEVb6JQQJ99AHACYeBjFAQpxuAAAgAZMPdFtn',
  },
  center: [0, 0],
  zoom: 2,
  style: 'satellite_road_labels', 
  showLogo: false,
  showFeedbackLink: false,
};

type MapProps = PropsFromRedux & {
  location: string; 
  projectName:string;
  pathCoordinates?: string[]; // Optional array of coordinate strings (e.g., ["itemMilestoneID,milestoneDate,lat,lng", ...])
};

type MapState = {
    geoFenceCoordinates: GEOFencingGroupCoordinates[];
    gotGeoFenceData: boolean,
    sasToken: string, 
    gotSASToken: boolean,
}

function Map(props: MapProps) {

    const [state, setState] = useState<MapState>({
        geoFenceCoordinates: [],
        gotGeoFenceData: false,
        sasToken:"",
        gotSASToken: false,
    });

    const [tooltipVisible, setTooltipVisible] = useState(false);
    const [tooltipContent, setTooltipContent] = useState('');
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

    const escapeHtml = (value: unknown) => {
      if (value === null || value === undefined) {
        return '';
      }

      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    };


  const mapRef = useRef<atlas.Map | null>(null);
  const mapContainerRef = useRef<HTMLDivElement>(null);
  const [lat, lng] = props.location.split(',').map(Number);

    const getSASToken = () => {

        let url = props.userInf.currProject.apiUrl + '/api/mapdata/GetAzureMapsSASToken';

                fetch(url, { method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + props.userInf.token } })
                    .then(resp => { if (!resp.ok) { throw Error(resp.statusText); } return resp; })
                    .then(resp => resp.json())
                    .then(res => {
                        if (res.callStatus !== "OK") {
                            throw Error(res.CallStatusMessage);
                        } else {

                          let sasToken = res.stringResponse;

                        setState((prevState) => {
                            const updatedState = {
                                ...prevState,
                                sasToken: sasToken,
                                gotSASToken: true,
                            };
                        
                            return updatedState; // Return the new state for setState
                        });

                        }
                    })
                    .catch(err => {
                        alert('Error getting GeoFence Data - ' + err.toString());
                    });

  };


  const getGeoFenceCoordinates = () => {

        let url = props.userInf.currProject.apiUrl + '/api/mapdata/GetGeoFencingPolygons';

                fetch(url, { method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + props.userInf.token } })
                    .then(resp => { if (!resp.ok) { throw Error(resp.statusText); } return resp; })
                    .then(resp => resp.json())
                    .then(res => {
                        if (res.callStatus !== "OK") {
                            throw Error(res.CallStatusMessage);
                        } else {

                          let gps : GEOFencingGroupCoordinates[] = res.results;

                        setState((prevState) => {
                            const updatedState = {
                                ...prevState,
                                geoFenceCoordinates: gps,
                                gotGeoFenceData: true,
                            };
                        
                            return updatedState; // Return the new state for setState
                        });

                        }
                    })
                    .catch(err => {
                        alert('Error getting GeoFence Data - ' + err.toString());
                    });

  };

useEffect(() => {
  // Skip geofence when using pathCoordinates
  if (!props.pathCoordinates) {
    getGeoFenceCoordinates();
  } else {
    setState((prevState) => ({
      ...prevState,
      gotGeoFenceData: true,
      geoFenceCoordinates: []
    }));
  }
},[]);

useEffect(() => {
  // Skip SAS token when using pathCoordinates
  if (!props.pathCoordinates || props.pathCoordinates.length === 0) {
    getSASToken();
  } else {
    setState((prevState) => ({
      ...prevState,
      gotSASToken: true,
      sasToken: ''
    }));
  }
},[]);

  useEffect(() => {
    if (mapRef.current || !mapContainerRef.current || !state.gotGeoFenceData || !state.gotSASToken) {
      return;
    }

    const map = new atlas.Map(mapContainerRef.current, {
      ...options,
      center: [lng, lat],
  zoom: 14,
    });

    mapRef.current = map;

    map.events.add('ready', () => {
      map.resize();

      // Only load custom tiles if not using pathCoordinates
      if (!props.pathCoordinates && state.sasToken) {
        const customTileUrl = "https://mmgmaps.blob.core.windows.net/azuremaps/" + props.projectName + "/{z}/{x}/{y}.png?" + state.sasToken;

        const TileLayer = new atlas.layer.TileLayer({
          tileUrl: customTileUrl,
          tileSize: 256,
          opacity: 1,
          visible: true,
        });

        map.layers.add(TileLayer);
      }

      const geoFenceDataSource = new atlas.source.DataSource()

         map.sources.add(geoFenceDataSource);

        // Parse and add each fence as a polygon (skip if no geofence data)
  if (state.geoFenceCoordinates.length > 0) {
    state.geoFenceCoordinates.forEach(fence => {

  if (!fence.gpsCoordinates || typeof fence.gpsCoordinates !== 'string') {
    console.warn('Skipping invalid fence:', fence);
    return;
  }

    // Remove square brackets and split into coordinate pairs
    const coords = fence.gpsCoordinates
      .replace(/\[|\]/g, '') // remove square brackets
      .split(',') // split on commas
      .map(coord => parseFloat(coord.trim())); // convert to float

    const polygonCoords: [number, number][] = [];

  for (let i = 0; i < coords.length; i += 2) {
    const lat = coords[i + 1];
    const lng = coords[i];
    if (!isNaN(lat) && !isNaN(lng)) {
      polygonCoords.push([lat, lng]);
    }
  }

    // Close the polygon (Azure Maps expects it)
    if (
      polygonCoords.length > 0 &&
      (polygonCoords[0][0] !== polygonCoords[polygonCoords.length - 1][0] ||
        polygonCoords[0][1] !== polygonCoords[polygonCoords.length - 1][1])
    ) {
      polygonCoords.push(polygonCoords[0]);
    }

    const polygon = new atlas.data.Polygon([polygonCoords]);
    const feature = new atlas.data.Feature(polygon, {
      title: fence.geoFencingGroup,
    });

    geoFenceDataSource.add(feature);
  })
  }

  // Only add polygon and label layers if we have geofence data
  if (state.geoFenceCoordinates.length > 0) {
    const polygonLayer = new atlas.layer.PolygonLayer(geoFenceDataSource, 'fenceLayer', {
      fillColor: 'rgba(253, 255, 128, 0.8)',
      strokeColor: 'white',
      strokeWidth: 2,
    });

    map.layers.add(polygonLayer);

    const labelLayer = new atlas.layer.SymbolLayer(geoFenceDataSource, 'labelLayer', {
      textOptions: {
        textField: ['get', 'title'], 
        color: 'black',
        size: 12,
        allowOverlap: true,
        placement: 'polygon',
      },
      iconOptions: {
        image: '', // ✅ Disables default pin icon
      }
    });

    map.layers.add(labelLayer);
  }

      // Shared variables for hover functionality
      let currentHoveredShape: atlas.Shape | null = null;
      let closeTimeout: NodeJS.Timeout | null = null;
      let waypointLayerRef: atlas.layer.BubbleLayer | null = null;

      // Render path if pathCoordinates are provided
      if (props.pathCoordinates && props.pathCoordinates.length > 0) {
        const pathDataSource = new atlas.source.DataSource();
        map.sources.add(pathDataSource);

        // Parse path coordinates and create line points (includes all points including destination)
        // Format: "itemMilestoneID,milestoneDate,lat,lng"
        const pathPoints: [number, number][] = props.pathCoordinates.map(coord => {
          const parts = coord.split(',');
          const coordLat = Number(parts[2]);
          const coordLng = Number(parts[3]);
          return [coordLng, coordLat]; // Azure Maps uses [lng, lat] format
        });

        // Create a LineString from the path points
        const lineString = new atlas.data.LineString(pathPoints);
        pathDataSource.add(new atlas.data.Feature(lineString));

        // Create and add the line layer
        const pathLayer = new atlas.layer.LineLayer(pathDataSource, 'pathLayer', {
          strokeColor: '#2563eb', // Blue color for the path
          strokeWidth: 3,
          strokeOpacity: 0.8,
        });

        map.layers.add(pathLayer);

        // Add red dots for each waypoint (all points except the last one which is the destination)
        const waypointDataSource = new atlas.source.DataSource();
        map.sources.add(waypointDataSource);

        // Add all points except the last one as waypoint markers with itemMilestoneID and milestoneDate
        for (let i = 0; i < pathPoints.length - 1; i++) {
          const parts = props.pathCoordinates[i].split(',');
          const itemMilestoneID = parts[0];
          const milestoneDate = parts[1];
          const waypointPoint = new atlas.data.Feature(new atlas.data.Point(pathPoints[i]), {
            itemMilestoneID: itemMilestoneID,
            milestoneDate: milestoneDate
          });
          waypointDataSource.add(waypointPoint);
        }

        // Create a bubble layer for the red waypoint dots
        const waypointLayer = new atlas.layer.BubbleLayer(waypointDataSource, 'waypointLayer', {
          color: '#dc2626', // Red color
          radius: 8,
          strokeColor: '#ffffff', // White border
          strokeWidth: 2,
        });

        map.layers.add(waypointLayer);

        // Store reference for combined hover handler
        waypointLayerRef = waypointLayer;

        // Calculate bounding box to fit all path points
        const lngs = pathPoints.map(p => p[0]);
        const lats = pathPoints.map(p => p[1]);
        const minLng = Math.min(...lngs);
        const maxLng = Math.max(...lngs);
        const minLat = Math.min(...lats);
        const maxLat = Math.max(...lats);

        // Create bounding box and zoom to fit
        const boundingBox = new atlas.data.BoundingBox([minLng, minLat, maxLng, maxLat]);
        map.setCamera({
          bounds: boundingBox,
          padding: 50 // Add padding around the bounds
        });
      }

      const pinDataSource = new atlas.source.DataSource();
      map.sources.add(pinDataSource);

      // Create the final destination point with itemMilestoneID and milestoneDate if available
      let pinFeature;
      if (props.pathCoordinates && props.pathCoordinates.length > 0) {
        // Get the last coordinate which should be the destination
        const lastCoord = props.pathCoordinates[props.pathCoordinates.length - 1];
        const parts = lastCoord.split(',');
        const itemMilestoneID = parts[0];
        const milestoneDate = parts[1];
        pinFeature = new atlas.data.Feature(new atlas.data.Point([lng, lat]), {
          itemMilestoneID: itemMilestoneID,
          milestoneDate: milestoneDate
        });
      } else {
        pinFeature = new atlas.data.Feature(new atlas.data.Point([lng, lat]));
      }
      
      pinDataSource.add(pinFeature);

      const symbolLayer = new atlas.layer.SymbolLayer(pinDataSource, 'pinLayer', {
        iconOptions: {
          image: 'marker-blue',
          allowOverlap: true,
        },
      });

      map.layers.add(symbolLayer);

      // Add combined hover detection for both waypoints and destination pin
      if (props.pathCoordinates && props.pathCoordinates.length > 0) {
        // Combine both layer references
        const layersToCheck = waypointLayerRef ? [waypointLayerRef, symbolLayer] : [symbolLayer];
        
        map.events.add('mousemove', (e) => {
          const shapes = map.layers.getRenderedShapes(e.position, layersToCheck);
          
          if (shapes.length > 0) {
            const shape = shapes[0] as atlas.Shape;
            
            // Clear any pending close timeout
            if (closeTimeout) {
              clearTimeout(closeTimeout);
              closeTimeout = null;
            }
            
            // Change cursor
            map.getCanvasContainer().style.cursor = 'pointer';
            
            // Only process if this is a new shape
            if (currentHoveredShape !== shape) {
              console.log('Waypoint or destination pin hovered');
              currentHoveredShape = shape;
              
              const position = shape.getCoordinates() as atlas.data.Position;
              const [lng, lat] = position;
              const properties = shape.getProperties();
              const milestoneDate = properties.milestoneDate;
              const itemMilestoneID = properties.itemMilestoneID;
              
              console.log('Point details:', { lat, lng, milestoneDate, itemMilestoneID, position });
              
              // Show loading tooltip
              setTooltipContent('<div class="vessel-popup"><div class="vessel-popup__body">Loading...</div></div>');
              if (e.pixel && mapContainerRef.current) {
                const rect = mapContainerRef.current.getBoundingClientRect();
                setTooltipPosition({ x: rect.left + e.pixel[0] + 10, y: rect.top + e.pixel[1] - 10 });
              }
              setTooltipVisible(true);
              console.log('Tooltip opened at pixel:', e.pixel);

              // Fetch vessel tracking data
              const url = `${props.userInf.currProject.apiUrl}/api/VesselTracking/GetVesselTrackingData?itemMilestoneID=${itemMilestoneID}&milestoneDate=${milestoneDate}&latitude=${lat}&longitude=${lng}`;
              
              console.log('Fetching vessel data from:', url);
              
              fetch(url, { 
                method: 'GET', 
                headers: { 
                  'Content-Type': 'application/json', 
                  'Authorization': 'Bearer ' + props.userInf.token 
                } 
              })
                .then(resp => { if (!resp.ok) { throw Error(resp.statusText); } return resp; })
                .then(resp => resp.json())
                .then(res => {
                  console.log('API Response received:', res);
                  if (res.callStatus !== "OK") {
                    throw Error(res.callStatusMessage || 'Unknown error');
                  } else {
                    // Format the vessel tracking data for display
                    const dataList = res.result;
                    let content = '<div class="vessel-popup">';
                    content += '<div class="vessel-popup__header">Vessel Tracking Data</div>';
                    content += '<div class="vessel-popup__body">';
                    
                    // Display vessel information from list of VesselPopupItem objects
                    if (Array.isArray(dataList)) {
                      dataList.forEach((item: { description: string; value: string }) => {
                        if (item.value) {
                          let label = item.description;
                          let value = item.value;
                          
                          // Add "knots" suffix for Vessel Speed
                          if (item.description === 'Vessel Speed') {
                            value = `${value} Kts`;
                          }
                          // Add "°" suffix for Vessel Course
                          if (item.description === 'Vessel Course') {
                            value = `${value}°`;
                          }
                          
                          content += `<div class="vessel-popup__row"><span class="vessel-popup__label">${escapeHtml(label)}:</span><span class="vessel-popup__value">${escapeHtml(value)}</span></div>`;
                        }
                      });
                    }
                    
                    content += '</div></div>';
                    
                    console.log('Setting tooltip content');
                    setTooltipContent(content);
                    console.log('Tooltip updated with vessel data');
                  }
                })
                .catch(err => {
                  console.error('Error fetching vessel data:', err);
                  setTooltipContent(`<div class="vessel-popup"><div class="vessel-popup__body vessel-popup__error">Error: ${escapeHtml(err.toString())}</div></div>`);
                });
            }
          } else {
            // Not over any point - delay closing tooltip
            if (currentHoveredShape && !closeTimeout) {
              console.log('Mouse left point, scheduling tooltip close');
              closeTimeout = setTimeout(() => {
                console.log('Closing tooltip after delay');
                currentHoveredShape = null;
                map.getCanvasContainer().style.cursor = 'grab';
                setTooltipVisible(false);
                closeTimeout = null;
              }, 500);
            }
          }
        });
      }


    });

    return () => {
      map.dispose();
        mapRef.current = null;
    }
  }, [state.gotGeoFenceData, state.gotSASToken, lat, lng, props.pathCoordinates]);

  return (
    <>
      <div style={{ height: '95%', width: '100%', position: 'relative', overflow: 'hidden' }}>
        <AzureMapsProvider>
          <div ref={mapContainerRef} style={{ height: '100%', width: '100%' }} />
        </AzureMapsProvider>
      </div>
      {tooltipVisible && ReactDOM.createPortal(
        <div 
          style={{
            position: 'fixed',
            left: `${tooltipPosition.x}px`,
            top: `${tooltipPosition.y}px`,
            zIndex: 99999,
            pointerEvents: 'none'
          }}
          dangerouslySetInnerHTML={{ __html: tooltipContent }}
        />,
        document.body
      )}
    </>
  );
}

export default connector(Map);
